import React from 'react';
import { SettingsHubSection } from '../SettingsHubSection';

const ProposalsSettingsSection: React.FC = () => (
  <SettingsHubSection section="proposals" />
);

export default ProposalsSettingsSection;
